import React, { useState } from "react";
import axios from "axios";

// import Files
import * as Config from "../Utils/Config";
import { header } from "../Utils/ApiHeader";

axios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      window.location.href = "/#/login";
      localStorage.clear();
    }
    return Promise.reject(err);
  }
);

// USER TRADING STATUS GET ALL
export async function user_getall_tradingstatus(data, token) {
  try {
    const res = await axios.post(
      `${Config.base_url}getall/user/trading_status`,
      data,
      {
        // headers: header(token),
        data: {},
      }
    );
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

// USER DASHBOARD
export async function USER_DASHBOARD(data, token) {
  try {
    const res = await axios.post(
      `${Config.base_url}getall/user/clientServices`,
      data,
      {
        headers: header(token),
      }
    );
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

// USER BROKER RESPONSE
export async function GET_BROKER_RESPONSE(data, token) {
  try {
    const res = await axios.post(
      `${Config.base_url}getall/user/brokeresponse`,
      data,   
      {
        headers: header(token),
      }
    );
    return res.data;
  } catch (err) {
    return err;
  }
}


// USER SIGNALS

export async function GET_SIGNALS(data, token) {
  try {
    const res = await axios.post(
      `${Config.base_url}getall/user/signals`,
      data,
      {
        headers: header(token),
        data: {},
      }
    );
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

// USER STRATEGY_DESCRIPTION

export async function STRATEGY_DESCRIPTION(data, token) {
  try {
    const res = await axios.post(
      `${Config.base_url}getall/user/strategy`,
      data,
      {
        headers: header(token),
        data: {},
      }
    );
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

// USER CREATE HELP

export async function CREATE_HELP(data, token) {
  try {
    const res = await axios.post(`${Config.base_url}create/user/help`, data, {
      headers: header(token),
      data: {},
    });
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

export async function GET_HELP(data, token) {
  try {
    const res = await axios.post(`${Config.base_url}getall/user/help`, data, {
      headers: header(token),
      data: {},
    });
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

// USER CREATE HELP
export async function UPDATE_DAHBOARD_DATA(data, token) {
  try {
    const res = await axios.post(
      `${Config.base_url}update/clientServices`,
      data,
      {
        headers: header(token),
        data: {},
      }
    );
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

// USER ACTIVICTY LOGS

export async function USER_ACTIVICTY_LOGS(data, token) {
  try {
    const res = await axios.post(
      `${Config.base_url}getall/user/update_somthing_status`,
      data,
      {
        headers: header(token),
        data: {},
      }
    );
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

export async function UPDATE_BROKER_KEYS(data, token) {
  try {
    const res = await axios.post(`${Config.base_url}update/brokerkeys`, data, {
      headers: header(token),
      data: {},
    });
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

// TRADING OFF

export async function TRADING_OFF(data, token) {
  try {
    const res = await axios.post(`${Config.base_url}trading/logout`, data, {
      headers: header(token),
      data: { data },
    });
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

export async function UpdateCashQty(data, token) {
  try {
    const res = await axios.post(`${Config.base_url}update/cashfunds`, data, {
      headers: header(token),
      data: { data },
    });
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

//
export async function Update_broker_response(data, token) {
  try {
    const res = await axios.post(
      `${Config.base_url}aliceblue/get/orderinfo`,
      data,
      {
        headers: header(token),
        data: { data },
      }
    );
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

//
export async function MODIFY_DETAILS(data, token) {
  try {
    const res = await axios.post(
      `${Config.base_url}update/modify_details`,
      data,
      {
        headers: header(token),
        data: { data },
      }
    );
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

//
export async function GET_PERMISSION(data, token) {
  try {
    const res = await axios.post(
      `${Config.base_url}get/panel/permission`,
      data,
      {
        headers: header(token),
        data: { data },
      }
    );
    if (res?.data?.status) {
      localStorage.setItem("panel_name", res?.data?.data[0]?.panel_name);
    }
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

//
export async function GET_ALL_BROKER_RESPONSE(user_id) {
  try {
    const res = await axios.post(
      `${Config.base_url}getall/order/info`,
      user_id,
      {
        // headers: header(token),
        data: {},
      }
    );
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

export async function GET_USER_BROKER_INFO(user_id, token) {
  try {
    const res = await axios.post(
      `${Config.base_url}get/user_api_create`,
      user_id,
      {
        headers: header(token),
        data: {},
      }
    );
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

export async function USER_FUND_UPDATE(user_id, token) {
  try {
    const res = await axios.post(`${Config.base_url}update/fund`, user_id, {
      headers: header(token),
      data: {},
    });
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

export async function USER_FUND_GETALL(user_id, token) {
  try {
    const res = await axios.post(`${Config.base_url}getall/fund`, user_id, {
      headers: header(token),
      data: {},
    });
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

export async function BrokerProfile(user_id, token) {
  try {
    const res = await axios.post(
      `${Config.base_url}brokerProfile_info`,
      user_id,
      {
        headers: header(token),
        data: {},
      }
    );
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

//
export async function GET_ALL_ORDERS(data) {
  try {
    const res = await axios.get(`${Config.base_url}getall/user/orders`, {
      headers: header(data?.token),
      params: { _id: data?._id }, // ✅ params object format
    });

    return res?.data;
  } catch (err) {
    return err.response?.data || err;
  }
}

export async function GET_ALL_TRADE_HISTORY(data, token) {
  try {

    const res = await axios.post(
      `${Config.base_url}getall/user/tradehistory`,
      data,                        // ✅ Request Body
      {
        headers: header(token),    // ✅ Headers / Token Config
      }
    );

    return res?.data;
  } catch (err) {
    return err.response?.data || err;
  }
}


// for maanual
export async function GET_ALL_MANUAL_TRADE_HISTORY(data, token) {
  try {

    const res = await axios.post(
      `${Config.base_url}getall/user/manualTradeHistory`,
      data,                        // ✅ Request Body
      {
        headers: header(token),    // ✅ Headers / Token Config
      }
    );

    return res?.data;
  } catch (err) {
    return err.response?.data || err;
  }
}


// trade/execute
export async function TRADE_EXECUTE(data) {
  try {
    const isLocalhost = window.location.hostname === "localhost";
    const url = isLocalhost
      ? "http://localhost:8000/trade/execute" // Local API
      : window.location.origin + "/signal/trade/execute"; // Live/Production API

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: url,
      headers: {
        "Content-Type": "text/plain",
      },
      data: data,
    };

    const res = await axios(config);
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

// getserviceName
export async function GET_SERVICE_NAME(data, token) {
  try {
    const res = await axios.post(`${Config.base_url}getserviceName`, data, {
      headers: header(token),
      data: {},
    });
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

export async function upadtetradingExpiryStatus(data) {
  try {
    const res = await axios.post(
      `${Config.base_url}tradingExpiryStatus`,
      data,
      {}
    );
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

export async function gettradingExpiry(data) {
  try {
    const res = await axios.post(
      `${Config.base_url}gettradingExpiryStatus`,
      data,
      {}
    );
    return await res?.data;
  } catch (err) {
    return await err;
  }
}

export async function getOpenOrder(data, token) {
  try {
    const params = new URLSearchParams(data).toString();
    const res = await axios.get(
      `${Config.base_url}getall/user/openOrder?${params}`,
      { headers: header(token) }
    );
    return res?.data;
  } catch (err) {
    return err.response?.data || err;
  }
}

export async function EditOpenOrderPrice(data, token) {
  try {
    const res = await axios.post(
      `${Config.base_url}edit/openOrderPrice`,
      data,
      {
        headers: header(token),
        timeout: 10000, // 10 second timeout
      }
    );

    return res.data;
  } catch (err) {
    console.error("EditOpenOrderPrice API error:", err); // Debug log

    if (err.response) {
      return err.response.data;
    } else if (err.request) {
      return { status: false, message: "No response from server" };
    } else {
      return { status: false, message: err.message };
    }
  }
}

// getQuantityUser
export async function getQuantityUser(data, token) {
  try {
    const res = await axios.post(`${Config.base_url}getQuantityUser`, data, {
      headers: header(token),
    });
    return await res?.data;
  } catch (err) {
    return await err;
  }
}
